import { useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { HelpCircle } from "lucide-react";
import { Card, Section } from "../Layout";
import { useI18n } from "../i18n";

function AccordionItem({ q, a }) {
  const [open, setOpen] = useState(false);

  return (
    <button
      className="w-full text-left p-4 sm:p-5 hover:bg-theme-border-light transition rounded-3xl"
      onClick={() => setOpen((value) => !value)}
      aria-expanded={open}
    >
      <div className="flex items-center justify-between gap-4">
        <p className="font-serif text-lg">{q}</p>
        <span className="text-theme-text-subtle">{open ? "—" : "+"}</span>
      </div>

      <AnimatePresence initial={false}>
        {open && (
          <motion.div
            initial={{ height: 0, opacity: 0 }}
            animate={{ height: "auto", opacity: 1 }}
            exit={{ height: 0, opacity: 0 }}
            transition={{ duration: 0.25 }}
            className="overflow-hidden"
          >
            <p className="mt-3 text-sm text-theme-text-muted pr-6">{a}</p>
          </motion.div>
        )}
      </AnimatePresence>
    </button>
  );
}

export default function FAQ() {
  const { t, get } = useI18n();
  const items = get("faq.items") || [];

  return (
    <Section id="faq" eyebrow={t("faq.eyebrow")} title={t("faq.title")} icon={HelpCircle}>
      <Card className="p-2 sm:p-3">
        <div className="divide-y divide-theme-border">
          {items.map((item) => (
            <AccordionItem key={item.q} q={item.q} a={item.a} />
          ))}
        </div>
      </Card>
    </Section>
  );
}
